import React from 'react';
import { Phone, Brain, Server, CheckCircle, ArrowRight } from 'lucide-react';

const WorkflowVisualization = () => {
  const steps = [
    { icon: Phone, label: 'Human', color: 'text-purple-400' },
    { icon: Phone, label: 'Voice', color: 'text-blue-400' },
    { icon: Brain, label: 'AI Agent', color: 'text-cyan-400' },
    { icon: Server, label: 'Enterprise Systems', color: 'text-green-400' },
    { icon: CheckCircle, label: 'Outcome', color: 'text-emerald-400' }
  ];

  return (
    <div className="flex items-center justify-center flex-wrap gap-4 py-8">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center space-y-2">
            <div className="w-16 h-16 rounded-full bg-gray-800/50 border border-gray-700 flex items-center justify-center hover:scale-110 transition-transform">
              <step.icon className={step.color} size={28} />
            </div>
            <div className="text-sm text-gray-400 font-medium">{step.label}</div>
          </div>
          {index < steps.length - 1 && (
            <ArrowRight className="text-gray-600 hidden sm:block" size={24} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default WorkflowVisualization;